/**
 * Atmosphärischer Shell-Hintergrund (1:1 zur Web-App):
 *  - festes, vollflächiges Hintergrundbild (bleibt beim Scrollen stehen),
 *  - dunkler Schleier darüber für Lesbarkeit.
 * Die radialen Teal/Orange-Auren liegen bereits auf <body> (global.css).
 * Bild je Kontext: Auth = bg18 (Sonnenaufgang), Kurs = bg14-flip-y (Himmel),
 * sonst bg07 (Teal-Gold-Aquarell). Bilder vom Static-Host (assetUrl).
 */
import { assetUrl } from "../data/assets";

export type BgVariant = "auth" | "course" | "default";

const IMAGE: Record<BgVariant, string> = {
  auth: "bg18.png",
  course: "bg14-flip-y.png",
  default: "bg07.png",
};

export function AppBackground({ variant }: { variant: BgVariant }) {
  const url = assetUrl(IMAGE[variant]) ?? "";
  return (
    <>
      <div
        aria-hidden="true"
        style={`position:fixed;inset:0;z-index:-2;background:url('${url}') center / cover no-repeat`}
      />
      <div
        aria-hidden="true"
        style="position:fixed;inset:0;z-index:-1;background:linear-gradient(180deg, rgba(0,23,23,.30), rgba(0,23,23,.52))"
      />
    </>
  );
}
